module.exports = __webpack_public_path__ + "img/banner-case.60f516c7.png";